import { Icon } from '@atom/mui';

import classes from './mapDrawerContent.module.css';

interface Props {
  icon: string;
  main: string;
  sub: string;
}

const InfoRow = ({ icon, main, sub }: Props) => {
  return (
    <div className={classes.basicInfoRow}>
      <Icon children={icon} />
      <div className={classes.dataContainer}>
        <div className={classes.dataLine}>{main}</div>
        <div className={classes.dataSubLine}>{sub}</div>
      </div>
    </div>
  );
};

export default InfoRow;
